import Vue from 'vue';
import Component from 'vue-class-component';


@Component({
props:{
    title:String,
    body:String,
    tcolor:String,
    bcolor:String
}
})
export default class ProductTabs extends Vue{
    tcolor:string;
    bcolor:string;

    isVisible:boolean = true;

  get  backgroundClass(){
      return this.bcolor=='beau'?{beau:true, laid:false}:{laid:true, beau:false};
  }

  get titleClass(){   
    return this.tcolor=='beau'?{beau:true, laid:false}:{laid:true, beau:false};
  }

  hideModal(){
    return this.isVisible=false;  
  }
}
